<div class="admin-request-details-page">
  <app-gradient class="gradient gradient__left"></app-gradient>
  <app-gradient class="gradient gradient__right"></app-gradient>
  <app-button
    class="request-back-button"
    [iconPosition]="'left'"
    (click)="backToRequests()"
    icon="arrow_back"
    [type]="'tertiary'"
    [size]="'small'"
    text="Back to Request list"></app-button>
  @if (adminService.request()?.brief) {
    <section class="admin-request-details-content">
      <header class="admin-request-details-header">
        <div class="request-details-header-content">
          <div class="request-details-header-details">
            <div class="request-details-header-details-title-content">
              <div class="request-details-header-details-title">
                <h1 class="heading-s">Request N° : {{adminService.request()?.id}}</h1>
                <div class="request-details-header-menu">
                  <app-button [size]="'medium'" #triggerMenu="matMenuTrigger"
                              (menuClosed)="closePopup()"
                              (click)="openPopup()"
                              [matMenuTriggerFor]="requestActions" [iconPosition]="'left'" [type]="'tertiary'" [icon]="'more_vert'"></app-button>
                </div>
              </div>
              <app-chip [type]="getStatusType(adminService.request()?.status)"  [text]="'back-office-status.' + adminService.request()?.status | translate" [size]="'medium'"></app-chip>
            </div>
            <div class="request-details-header-details-content">
              <div class="request-details-end-use-container">
                <span class="body-m text-color-alt">Product use: </span>
                <div class="request-details-end-use-content">
                  <mat-icon [svgIcon]="adminService.request()?.brief?.endUse?.icon ?? ''" class="end-use-icon"></mat-icon>
                  <span class="body-m text-color-default">{{ adminService.request()?.brief?.endUse?.name }}</span>
                </div>
              </div>
              <div class="request-details-target-container">
                <span class="body-m text-color-alt">Target: </span>
                <div class="target-list">
                  @if (adminService.request()?.brief?.age) {
                    <app-chip [type]="'trend'" [text]="adminService.request()?.brief?.age?.name ?? ''" [size]="'small'"></app-chip>
                  }
                  @if(adminService.request()?.brief?.gender) {
                    <app-chip [type]="'trend'" [text]="adminService.request()?.brief?.gender?.name ?? ''" [size]="'small'"></app-chip>
                  }
                  @if(adminService.request()?.brief?.marketSegment) {
                    <app-chip [type]="'trend'" [text]="adminService.request()?.brief?.marketSegment?.name ?? ''" [size]="'small'"></app-chip>
                  }
                  @if(adminService.request()?.brief?.distributionChannel) {
                    <app-chip [type]="'trend'" [text]="adminService.request()?.brief?.distributionChannel?.name ?? ''" [size]="'small'"></app-chip>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="request-details-header-actions">
            <app-button
              [text]="adminService.canSubmit() ? 'Submit' : 'Save'"
              [iconPosition]="'left'"
              [size]="'medium'"
              [disabled]="checkDisabled()"
              [type]="adminService.canSubmit() ? 'primary' : 'secondary'"
              (click)="saveOrSubmitProducts()"
              [icon]="adminService.canSubmit() ? 'send' : 'save'"></app-button>
          </div>
        </div>
        <mat-tab-nav-panel #tabPanel>
          <nav class="requests-nav" mat-tab-nav-bar [tabPanel]="tabPanel">
            <a class="body-m request-list-nav"
               mat-tab-link
               (click)="activeTab = 'proposals'"
               [ngClass]="{ 'active-link': activeTab === 'proposals' }">
              Proposals
            </a>
            <a class="body-m request-list-nav"
               mat-tab-link
               (click)="activeTab = 'details'"
               [ngClass]="{ 'active-link': activeTab === 'details' }">
              Request detail
            </a>
          </nav>
        </mat-tab-nav-panel>
      </header>
      <div class="admin-request-details-container">
        @if (activeTab === 'proposals') {
          <div class="admin-request-details-left-side">
            <div class="admin-request-left-side-item">
              <div *ngTemplateOutlet="contentTitle; context: {title: 'Brief'}"></div>
              <div class="left-side-item-content">
                @if (adminService.request()?.fragranceProfiles?.[0]?.inspiration1) {
                  <div *ngTemplateOutlet="contentData; context: {title: 'Inspiration 1', data: adminService.request()?.fragranceProfiles?.[0]?.inspiration1}"></div>
                }
                @if (adminService.request()?.fragranceProfiles?.[0]?.inspiration2) {
                  <div *ngTemplateOutlet="contentData; context: {title: 'Inspiration 2', data: adminService.request()?.fragranceProfiles?.[0]?.inspiration2}"></div>
                }
                @if (adminService.request()?.fragranceProfiles?.[0]?.noteSuggestions?.length ?? 0 > 0 || adminService.request()?.fragranceProfiles?.[0]?.noteComment) {
                  <div *ngTemplateOutlet="contentNotes; context: {title: 'Notes', comment: adminService.request()?.fragranceProfiles?.[0]?.noteComment, notes: transformRequestNotes(adminService.request()?.fragranceProfiles?.[0])}"></div>
                }
                @if (adminService.request()?.brief?.dosage) {
                  <div *ngTemplateOutlet="contentData; context: {title: 'Dosage', data: adminService.request()?.brief?.dosage}"></div>
                  <div *ngTemplateOutlet="contentData; context: {title: 'Dosage Mandatory', data: adminService.request()?.brief?.isMandatoryDosage ? 'Yes' : 'No'}"></div>
                }
                @if (adminService.request()?.brief?.estimatedVolume && adminService.request()?.brief?.estimatedVolume !== '0' && getVolumeInfo(adminService.request()?.brief?.estimatedVolume ?? '')) {
                  <div *ngTemplateOutlet="contentData; context: {title: 'Estimated Volume', data: getVolumeInfo(adminService.request()?.brief?.estimatedVolume ?? '')}"></div>
                }
                @if (adminService.request()?.brief?.finalComment) {
                  <div *ngTemplateOutlet="contentData; context: {title: 'Comment', data: adminService.request()?.brief?.finalComment}"></div>
                }
              </div>
            </div>
          </div>
          <div class="admin-request-details-right-side">
            <div class="request-proposals">
              <div class="request-proposals-header">
                <span class="heading-xs text-color-default">Proposals</span>
              </div>
              @if (adminService.selectedProducts(); as products) {
                @for(product of products; track product){
                  <app-admin-product-card [product]="product"
                                          (remove)="onRemoveProduct(product)"
                                          (editedProduct)="onProductUpdated($event)">
                  </app-admin-product-card>
                }
              }
              @if (checkDisplayAddProposals()) {
                <div class="request-proposals-placeholder">
                  <span class="heading-xs text-color-default">Add proposals</span>
                  <div class="request-proposals-actions">
                    <app-button type="secondary" iconPosition="left" icon="search" size="large" text="Search product" (click)="openProductsSearchModal()"></app-button>
                    <!-- <app-button type="tertiary" iconPosition="left" icon="add_circle" size="large" text="Create new product"></app-button> -->
                  </div>
                </div>
              }
            </div>
          </div>
        } @else if (activeTab === 'details') {
          <div class="admin-request-details-left-side">
            <div class="admin-request-left-side-item">
              <div *ngTemplateOutlet="contentTitle; context: {title: 'Client information'}"></div>
              <div class="left-side-item-content">
                @if (adminService.request()?.contact) {
                  <div *ngTemplateOutlet="contentData; context: {title: 'Name', data: adminService.request()?.contact?.firstname + ' ' + adminService.request()?.contact?.lastname}"></div>
                  <div *ngTemplateOutlet="contentData; context: {title: 'Company', data: adminService.request()?.contact?.companyName}"></div>
                  <div *ngTemplateOutlet="contentData; context: {title: 'Email', data: adminService.request()?.contact?.email}"></div>
                  <div *ngTemplateOutlet="contentData; context: {title: 'Phone number', data: adminService.request()?.contact?.phone}"></div>
                }
              </div>
            </div>
          </div>
          <div class="admin-request-details-right-side">
            <div class="request-details">
              <div class="request-details-comment">
                <span class="body-l-bold text-color-default">Comment</span>
                <mat-form-field class="request-details-comment__input" appearance="fill">
                  <textarea matInput [(ngModel)]="adminService.requestComment" placeholder="Enter a comment on the Request, the client folluw-up or the proposals" maxlength="2000"></textarea>
                </mat-form-field>
                <app-button type="secondary" size="small" text="Add comment" (click)="adminService.saveComment()" [disabled]="!adminService.requestComment()"></app-button>
              </div>
              <div class="request-details-history">
                <span class="body-l-bold text-color-default">Request history</span>
                <div class="request-history-list">
                  @if (adminService.requestHistory()) {
                    @for (comment of adminService.requestHistory()?.comments; track comment.createdAt) {
                      <div *ngTemplateOutlet="historyItem; context: {icon: 'message', title: 'Comment', date: comment.createdAt, by: comment.createdBy, message: comment.comment}"></div>
                    }
                  }
                  <div *ngTemplateOutlet="historyItem; context: {icon: 'fact_check', title: 'Request creation', date: adminService.request()?.createdAt}"></div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </section>
  }
</div>

<ng-template #contentTitle let-title="title">
  <div class="left-side-item-title">
    <span class="body-l-bold text-color-default">{{title}}</span>
  </div>
</ng-template>

<ng-template #contentData let-title="title" let-data="data">
  <div class="left-side-item-content-data">
    <span class="body-s text-color-alt">{{ title }}</span>
    <span class="body-m text-color-default">{{data}}</span>
  </div>
</ng-template>

<ng-template #contentNotes let-title="title" let-notes="notes" let-comment="comment">
  <div class="left-side-item-content-data">
    <span class="body-s text-color-alt">{{ title }}</span>
    @if (comment) {
      <span class="body-m text-color-default">{{comment}}</span>
    }
    @if (notes && notes.length > 0) {
      <div class="left-side-item-content-notes">
        @for (note of notes; track note) {
          <app-chip [type]="'trend'" [text]="note" [size]="'small'"></app-chip>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #historyItem let-icon="icon" let-title="title" let-by="by" let-message="message" let-date="date">
  <div class="request-history-item">
    <div class="history-item-timeline">
      <div class="line"></div>
      <div class="dot"></div>
    </div>
    <div class="history-item-message">
      <div class="history-item-message-wrapper">
        <div class="history-item-message-header">
          <div class="icon-wrapper">
            <mat-icon>{{icon}}</mat-icon>
          </div>
          <div class="title-wrapper">
            <div class="history-item-title">
              <span class="body-m-bold text-color-default">{{title}}</span>
              <span class="body-s text-color-alt">{{(date) | date: 'dd/MM/yyyy - HH:mm'}}</span>
            </div>
            @if (by) {
              <div class="history-item-by-wrapper">
                <span class="body-s text-color-alt">by &nbsp;</span><span class="body-s text-color-link">{{by}}</span>
              </div>
            }
          </div>
        </div>
        @if (message) {
          <div class="history-item-message-details">
            <span class="body-m text-color-alt">{{message}}</span>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>

<mat-menu #requestActions xPosition="after">
  <div (click)="$event.stopPropagation()" class="request-header-popup-wrapper">
    <a class="request-header-popup-item">
      <div class="content">
        <mat-icon>archive</mat-icon>
        <p class="body-m">Archive</p>
      </div>
    </a>
    <a class="request-header-popup-item">
      <div class="content">
        <mat-icon>calendar_today</mat-icon>
        <p class="body-m">Change expiration date</p>
      </div>
    </a>
  </div>
</mat-menu>
